
import Vue from 'vue';

export default Vue.extend({
  props: {
    withLabel: {
      type: Boolean,
      default: true,
    },
  },
});
